import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'DM',
    name: 'David M.',
    loc: '📍 Minnesota | Head Youth Hockey Director',
    quote: 'Finally, a resource that speaks the language of a modern coach. I organized my full U14 and U18 season programming in a single afternoon. Pure gold.'
  }, {
    initials: 'ES',
    name: 'Erik S.',
    loc: '📍 Sweden | Professional Coach',
    quote: "My sessions finally have a professional flow. I don't spend Sunday nights on YouTube anymore. This gave me my time back."
  }, {
    initials: 'SL',
    name: 'Sarah L.',
    loc: '📍 Toronto | U18 Coach',
    quote: 'The tactical schemes are elite. Saved me hours of prep and the players are responding incredibly well to the new structure.'
  }, {
    initials: 'CR',
    name: 'Chris R.',
    loc: '📍 Boston | Academy Director',
    quote: 'Running a full academy and having every practice coordinated is a dream. The Clear Cue Bank changed the way my players understand the toughest drills.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    loc: '📍 Buenos Aires | Hockey Coach',
    quote: 'My teams are far more focused. The analogies in the Cue Bank really work. What I value most is that everything is organized by age-specific block.'
  }, {
    initials: 'VT',
    name: 'Valerie T.',
    loc: '📍 London | Professional Coach',
    quote: 'The ready-made blueprints with built-in assessments save me at least 3 hours a week. It is like having an expert colleague who already did all the heavy lifting for me.'
  }];
  return <section className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-245">
      <div className="max-w-6xl mx-auto" data-id="element-246">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-20 max-w-4xl mx-auto leading-tight" data-id="element-247">
          WHAT COACHES WHO ALREADY HAVE{' '}
          <span className="text-brand-accent" data-id="element-248">ICE HOCKEY READY SAY:</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-249">
          {testimonials.map((test, i) => <div key={i} className="bg-brand-card rounded-3xl p-10 border border-brand-border" data-id="element-250">
              <div className="flex items-center gap-5 mb-8" data-id="element-251">
                <div className="w-16 h-16 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-2xl flex-shrink-0" aria-hidden="true" data-id="element-252">
                  {test.initials}
                </div>
                <div data-id="element-253">
                  <div className="text-brand-accent mb-2 text-sm" aria-label="5 stars" data-id="element-254">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-bold text-white text-xl mb-1" data-id="element-255">
                    {test.name}
                  </p>
                  <p className="text-sm text-white/70 font-medium" data-id="element-256">
                    {test.loc}
                  </p>
                </div>
              </div>
              <blockquote className="text-white/80 italic leading-relaxed text-lg" data-id="element-257">
                "{test.quote}"
              </blockquote>
            </div>)}
        </div>
      </div>
    </section>;
}